import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const AnnouncementBar = () => {
  return (
    <div className="bg-ink-navy text-white py-2 text-center text-xs font-bold tracking-widest uppercase flex items-center justify-center gap-4 border-b-2 border-white/10">
      <span className="flex items-center gap-1"><SafeIcon name="Truck" className="text-lemon-yellow" /> Free Shipping over $50</span>
      <span className="hidden sm:inline opacity-30">|</span>
      <span className="hidden sm:flex items-center gap-1"><SafeIcon name="ShieldCheck" className="text-sky-blue" /> Safety Tested & Approved</span>
    </div>
  );
};

export default AnnouncementBar;